import type { MigrationReviewView } from "~/helpers/aiChat/migrationReview";

import { useEffect, useMemo, useState } from "react";

import migrationReview from "~/helpers/aiChat/migrationReview";
import { useGetMigrationReviewQuery } from "~/services/endpoints/apiEndpoints";

export interface UseFernieMigrationReviewOptions {
	journeyId: string | null;
}

export interface UseFernieMigrationReviewReturn extends MigrationReviewView {
	isError: boolean;
	journeyId: string | null;
	refetch: () => void;
}

const useFernieMigrationReview = ({ journeyId }: UseFernieMigrationReviewOptions): UseFernieMigrationReviewReturn => {
	const [isPolling, setIsPolling] = useState(false);
	const { currentData, isError, refetch } = useGetMigrationReviewQuery(
		{ journeyId: journeyId ?? "" },
		{ pollingInterval: isPolling ? migrationReview.preparationPollMs : 0, refetchOnFocus: true, skip: !journeyId }
	);
	const view = useMemo(() => migrationReview.buildReview(currentData, journeyId), [currentData, journeyId]);

	useEffect(() => {
		setIsPolling(view.isPreparing);
	}, [view.isPreparing]);

	return { ...view, isError, journeyId, refetch };
};

export default useFernieMigrationReview;
